<template>
  <span>
    <cv-interactive-tooltip
      class="richtext-tooltip"
      direction="bottom"
      :alignment="tooltipAlignment"
    >
      <template #trigger>
        <div v-safe-html="label" />
      </template>
      <template #content>
        <p>{{ tip }}</p>
      </template>
    </cv-interactive-tooltip>
  </span>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useDynamicMountChild } from "@plugins/common/composables/dynamic-mount-child.ts";
import DeviceUtils from "@utils/device.utils.ts";

const props = withDefaults(
  defineProps<{
    context?: Record<string, unknown>;
    label: string;
    tip: string;
    id: string;
    // eslint-disable-next-line vue/prop-name-casing
    dynamicMountChildMixin_parentComponent?: object;
    // eslint-disable-next-line vue/prop-name-casing
    dynamicMountChildMixin_isDynamicallyMounted?: boolean;
  }>(),
  {
    context: () => ({}),
    dynamicMountChildMixin_parentComponent: () => ({}),
    dynamicMountChildMixin_isDynamicallyMounted: false,
  },
);

const tooltipAlignment = computed(() => {
  return DeviceUtils.isMobile() ? "start" : "center";
});

useDynamicMountChild({
  dynamicMountChildMixin_parentComponent: props.dynamicMountChildMixin_parentComponent,
  dynamicMountChildMixin_isDynamicallyMounted: props.dynamicMountChildMixin_isDynamicallyMounted,
});

const emit = defineEmits<(e: "loaded", id: string) => void>();

onMounted(() => {
  emit("loaded", props.id);
});
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";
.richtext-tooltip {
  display: inline-block;
  .bx--tooltip__label {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
  .bx--tooltip__trigger {
    text-align: inherit;
    color: $link-01;
    font-size: inherit !important;
    font-weight: inherit;
    font-style: inherit;
    line-height: inherit;
    text-decoration: underline;
    text-decoration-style: dotted;
  }
}
</style>
